import React from 'react';
import { Link } from 'react-router-dom';
import { PATH_SEGMENTS, route } from '../config/paths';
import '../styles/screens/LiveAssist.css';

/**
 * Entry point for Live Assist: choose real-time HTTP session vs recorded replay.
 */
const LiveAssistHub: React.FC = () => {
  return (
    <div className="live-assist-hub">
      <h1>Live Assist</h1>
      <p>
        Run a real-time assist session (manual text, browser speech-to-text, or server file transcription) or replay a
        recorded interaction with the agent assist panel (compact, focus, or full timeline).
      </p>
      <div className="live-assist-hub-cards">
        <Link className="live-assist-hub-card" to={route(PATH_SEGMENTS.LIVE_ASSIST, PATH_SEGMENTS.LIVE_ASSIST_LIVE)}>
          <div className="live-assist-hub-card-title">Real-time session</div>
          <div className="live-assist-hub-card-desc">
            Create a session, send turns over HTTP, optional mic captions (Chrome) → ingest-text; compare compact card,
            focus live, or full timeline (same TA payload as the analyzer).
          </div>
        </Link>
        <Link className="live-assist-hub-card" to={route(PATH_SEGMENTS.LIVE_ASSIST, PATH_SEGMENTS.LIVE_ASSIST_REPLAY)}>
          <div className="live-assist-hub-card-title">Replay</div>
          <div className="live-assist-hub-card-desc">
            Pick an interaction from the list, then open replay with audio and transcript-driven timeline.
          </div>
        </Link>
        <Link className="live-assist-hub-card" to={route(PATH_SEGMENTS.INTERACTIONS)}>
          <div className="live-assist-hub-card-title">Interactions</div>
          <div className="live-assist-hub-card-desc">Browse recordings; use an interaction id in replay when ready.</div>
        </Link>
      </div>
    </div>
  );
};

export default LiveAssistHub;
